module.exports = __webpack_public_path__ + "img/wx_erwei.854e90d1.png";